module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4yMTEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNi4yMTEgMTQiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNmY2MzMjY7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMSwxNkgxNy4yMTFMOS4xMDUsMlptOC44NDItMi4yMTFIOC4zNjhWMTIuMzE2SDkuODQyWm0wLTIuOTQ3SDguMzY4VjcuODk1SDkuODQyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTIpIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ic_notfall.svg
// module id = ppBh
// module chunks = 1